module.exports = __webpack_public_path__ + "static/header_about-b9c0c04a25014662f1158ac15a204754.jpg";